export default function minimumLengthValidator(val, minLength) {
    return val && val.length > minLength;
}